import clsx from 'clsx';
import React from 'react';
import AppTooltip from '../../../../components/shared/AppTooltip';

const WelcomeBanner = ({ styles, welcomeBannerMetaData, limits = {} }) => {

  const {welcomeText, bellIconLabel, belIconToolTip, communicationPrefLink} = welcomeBannerMetaData; 
  return(
    <div className={clsx(styles.bannerWrapper, 'd-flex justify-between')}>
      <div className={styles.bannerInnerWrapper}>
        <div className={styles.welcomeText}>{welcomeText}!</div>
        <div className={styles.bannerText}>
          <span className={styles.expiryText}>{limits.expiryText}</span>{' '}
        </div>
      </div>
      <div className="align-items-center d-flex gap-md">
        <button
          type="button"
          data-tip
          data-for="tooltip_bell_icon"
          data-class="tooltip"
          className={clsx(styles.btnLogout, 'd-flex flex-col align-items-center no-border none-bg')}
          onClick={() => {
            window.open(
              communicationPrefLink,
              '_blank',
              'width=600,height=600,noopener,noreferrer'
            );
          }}
        >
          <i className="material-symbols-outlined text-4xl">notifications</i>
          {bellIconLabel}
        </button>

        <AppTooltip
          id="tooltip_bell_icon"
          place="top"
          type="dark"
          borderColor="#cecece"
          arrowColor="#000"
          delayShow={400}
        >
         {belIconToolTip}
        </AppTooltip>
        <a
          className={clsx(styles.btnLogout, 'd-flex flex-col align-items-center')}
          href="/message?message=member_self_serve.mss_member_logged_out"
        >
          <i className="material-symbols-outlined text-4xl">logout</i>
          Logout
        </a>
      </div>
    </div>
  );
}

export default WelcomeBanner;
